export default "/static/explore/b946185d86a00c241a56a2bd371c89821aef0275/_next/static/images/header-image-chocolate-lover-353bb0f1b1024245ae9e970204368505.png";